import React, { useEffect, useContext } from 'react'
import { FormControl, Select, MenuItem, makeStyles } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Context as PortfolioContext } from '../contexts/portfolio'

const useStyles = makeStyles({
  menuDateGroup: {
    '& .MuiPaper-root': {
      '& .MuiList-root': {
        padding: 0,
        borderRadius: 'unset',
        '& .MuiButtonBase-root': {
          minHeight: 'unset',
          fontSize: 14,
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#474747',
        },
      },
    },
  },
  formControlDate: {
    width: '100%',
    minWidth: 145,
    '& .MuiFormLabel-root': {
      fontSize: 14,
      lineHeight: '18px',
      transform: 'none',
      marginBottom: 8,
      position: 'unset',
      cursor: 'pointer',
    },
    '& .MuiInputBase-root': {
      height: 40,
      marginTop: 'unset',
      backgroundColor: '#F4F5F7',
      borderRadius: '3px',
      display: 'unset',
      '& .MuiSelect-root': {
        height: '100%',
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 'normal',
        color: '#474747',
        padding: '0px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'transparent !important',
        paddingLeft: 10,
      },
      '& svg': {
        cursor: 'pointer',
        position: 'absolute',
        right: 10,
        top: 9,
        width: 24,
        height: 22,
        '& path': {
          stroke: '#8C8C8C',
        },
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
  },
  filter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: 14,
    '& > .MuiFormControl-root': {
      maxWidth: 120,
    },
  },
  ExpandMoreIcon: {},
})
interface FilterBoxProps {
  title: string
  data: any
  setFilterValue: any
  defaultValue: any
  reset?: boolean
  status?: any
}

const FilterBox = ({
  title,
  data,
  setFilterValue,
  defaultValue,
  reset,
  status,
}: FilterBoxProps) => {
  const classes = useStyles()
  const [filterBy, setFilterBy] = React.useState(defaultValue)
  const { setLoading } = useContext(PortfolioContext)

  const handleChangeFilterBy = (event: any) => {
    setLoading(true)
    if (status) {
      setFilterBy(event.target.value)
      setFilterValue(event.target.value)
    } else {
      setFilterBy(event.target.value.id)
      setFilterValue(event.target.value)
    }
  }

  useEffect(() => {
    setLoading(true)
    setFilterValue(defaultValue)
    setFilterBy(defaultValue)
  }, [reset])

  return (
    <div className={classes.filter}>
      {title}
      <FormControl className={classes.formControlDate}>
        <Select
          labelId="portfolio-filter-group"
          id="portfolio-filter-group"
          value={filterBy}
          onChange={handleChangeFilterBy}
          displayEmpty
          defaultValue={defaultValue}
          IconComponent={() => (
            <ExpandMoreIcon className={classes.ExpandMoreIcon} />
          )}
          MenuProps={{ className: classes.menuDateGroup }}
          renderValue={() => {
            if (!status) {
              return data[defaultValue].value
            }
            return filterBy.value
          }}
        >
          {data.map((i: any) => (
            <MenuItem key={i.id} value={i}>
              {i.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default FilterBox
